import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GcpCertApprovalRequest } from "../../types/gcpCert";
import api from "../../api";

const useAcceptGcpCert = (gcpCertID: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (gcpCertApproval: GcpCertApprovalRequest) => {
      return api.gcpCerts.approveCert(gcpCertApproval)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gcpCerts'] })
      queryClient.invalidateQueries({ queryKey: ['gcpCert', gcpCertID] })
    }
  })
}

export default useAcceptGcpCert